import React, {useEffect, useState} from "react";
import {getDanai} from "../../util/ajax";

function Content() {
    const [content, setContent] = useState('');
    useEffect(() => {
        getDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/terms-and-condition', function (resp) {
            setContent(resp.content);
            console.log(resp);
        }, function () {

        });
    }, []);

    return (
        <>
            <div className="breadcrumb-wrapper-promo-detail" style={{margin: '5em 2em'}}>
                <h1 className="mb-0" style={{color: "#272727"}}>Syarat dan Ketentuan</h1>
                <div dangerouslySetInnerHTML={{__html: content}} className="terms-condition"/>
            </div>
        </>
    )
        ;
}

export default Content;
